export default "__VITE_ASSET__BsTt07Yq__"